import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { httpRequest } from '../services/httpService';
import { useSnackbar } from '../contexts/SnackbarContext';
import PropTypes from 'prop-types';
import ConfirmationDialog from './ConfirmationDialog'; // Import ConfirmationDialog

FileDelete.propTypes = {
    fileId: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default function FileDelete({ fileId, onDelete, size = 'small' }) {
    const showSnackbar = useSnackbar();
    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false); // State for dialog

    const handleDelete = async () => {
        try {
            await httpRequest(
                `/api/file/delete/${fileId}`,
                { method: 'POST' },
                showSnackbar,
                'Archivo eliminado'
            );
            if (onDelete) {
                onDelete(fileId); // Notify parent component about the deletion
            }
        } catch (error) {
            console.error('Error deleting file:', error);
        } finally {
            setConfirmationDialogOpen(false); // Close dialog after deletion
        }
    };

    return (
        <>
            <IconButton
                onClick={(event) => {
                    event.stopPropagation();
                    setConfirmationDialogOpen(true); // Open confirmation dialog
                }}
                color="warning"
            >
                <DeleteIcon fontSize={size}  />
            </IconButton>

            {/* Confirmation Dialog */}
            <ConfirmationDialog
                open={confirmationDialogOpen}
                title="Confirmar Eliminación"
                message="¿Estás seguro de que deseas eliminar este archivo?"
                confirmButtonText="Eliminar"
                confirmButtonColor="warning"
                onClose={() => setConfirmationDialogOpen(false)} // Close dialog
                onConfirm={handleDelete} // Confirm deletion
            />
        </>
    );
}
